export const getApiUrl = () => {
    // If securely defined in build (production), use it
    if (import.meta.env.VITE_API_URL && !import.meta.env.DEV) {
        return import.meta.env.VITE_API_URL;
    }
    // Dynamic detection for dev/local network
    if (typeof window !== 'undefined') {
        const { protocol, hostname } = window.location;
        // If localhost or IP, assume backend is on port 3000
        return `${protocol}//${hostname}:3000/api`;
    }
    return 'http://localhost:3000/api';
};

export const API_URL = getApiUrl();
